import { apiClient } from "api/trpc/trpc-client"
import { makeAutoObservable } from "mobx"
import ObservablePromise from "reusable/mobx-store-utils/observablePromise"

export default class MigrationsStore {
   migrations

   constructor() {
      makeAutoObservable(this)
      this.migrations = new ObservablePromise(apiClient.dev.getAllMigrations.query())
   }

}
